import 'dom-slider';

VIV.behaviours.pageMenu = (function () {

    const attach = function (context) {
        context.querySelectorAll('.pageMenu').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {
        const {slideDown, slideUp, slideToggle} = window.domSlider
        const toggleLinks = element.querySelectorAll('.pageMenu__link--withChildren');
        toggleLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                link.classList.toggle('pageMenu__link--open');
                link.parentElement.classList.toggle('pageMenu__item--open');
                slideToggle({element: link.parentElement.lastElementChild});
            });
        })
    };

    return {
        attach: attach
    }
})();
